import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { countryCodes } from "../../config/country-codes";
import { editStatus } from "../../http/http-calls";
import { convertUrlToCdn } from "../../helper-methods";
const EditMemberModal = ({ isOpen, toggle, editUserDetail, memberDetail }) => {
  console.log("editUserDetail", editUserDetail);
  //state

  const [formData, setFormData] = useState({
    name: "",
    countryCode: "",
    phone: "",
    email: "",
  });

  const [prevData, setPrevData] = useState({
    name: "",
    countryCode: "",
    phone: "",
    email: "",
  });

  useEffect(() => {
    if (editUserDetail !== null) {
      let phoneNumber = editUserDetail?.phone?.split("-");

      setFormData({
        name: editUserDetail?.fullname,
        countryCode: editUserDetail?.phone ? phoneNumber[0] : "",
        phone: editUserDetail?.phone ? phoneNumber[1] : "",
        email: editUserDetail?.email,
      });
      setPrevData({
        name: editUserDetail?.fullname,
        countryCode: editUserDetail?.phone ? phoneNumber[0] : "",
        phone: editUserDetail?.phone ? phoneNumber[1] : "",
        email: editUserDetail?.email,
      });
    }
  }, [editUserDetail]);

  const _closeModal = () => {
    toggle();
    setFormData({
      name: "",
      countryCode: "",
      phone: "",
      email: "",
    });
    setPrevData({
      name: "",
      countryCode: "",
      phone: "",
      email: "",
    });
  };

  //onChnage handler
  const _handelOnChange = (field, event) => {
    const newFormData = { ...formData };

    newFormData[field] = event.target.value;

    setFormData(newFormData);
  };

  const _editUserHandler = async () => {
    console.log("formData", formData);
    try {
      const res = await editStatus(editUserDetail?._id, {
        email: formData?.email,
      });
      console.log("updatedEmailRes>>>>", res);
    } catch (error) {
      console.log("error", error);
    }
    _closeModal();
    memberDetail();
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={() => _closeModal()}
      scrollable
      centered
    >
      <ModalHeader toggle={() => _closeModal()}>Edit Member</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12} className="d-flex justify-content-center mb-4">
            <div className="userProfile vertical-align">
              <img
                src={
                  editUserDetail?.displaypictureurl
                    ? convertUrlToCdn(editUserDetail?.displaypictureurl)
                    : require("../../assets/img/1.png")
                }
                alt="category"
                className="img-fluid"
                loading="lazy"
              />
            </div>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>Name</Label>
              <Input
                type="text"
                placeholder="Enter"
                value={formData?.name}
                onChange={(event) => console.log()}
                disabled
              />
            </FormGroup>
          </Col>
          <Col lg={6} className="input-group-phone-error">
            <FormGroup>
              <Label>Phone Number</Label>
              <InputGroup className="countryCode flex-nowrap">
                <div>
                  <InputGroupText>
                    <img
                      src={require("../../assets/img/phone.svg").default}
                      alt="user"
                      className="img-fluid"
                    />
                    <Input
                      type="select"
                      className="pl-0"
                      value={formData?.countryCode}
                      disabled
                      onChange={(event) => console.log()}
                    >
                      <option>select</option>
                      {countryCodes.map((each) => (
                        <option key={each.code} value={each.dial_code}>
                          {each.code} ({each.dial_code})
                        </option>
                      ))}
                    </Input>
                  </InputGroupText>
                </div>
                <div className="position-relative">
                  <Input
                    type="text"
                    placeholder="Enter"
                    value={formData?.phone}
                    disabled
                    autoComplete="off"
                    onChange={(event) => console.log()}
                  />
                </div>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>Email</Label>
              <Input
                type="email"
                placeholder="Enter"
                value={formData?.email}
                onChange={(event) => _handelOnChange("email", event)}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="closeBtn" onClick={() => _closeModal()}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => _editUserHandler()}
          disabled={JSON.stringify(prevData) === JSON.stringify(formData)}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditMemberModal;
